import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var AnchorButton = function AnchorButton(_ref) {
  var href = _ref.href,
    className = _ref.className,
    children = _ref.children,
    onClick = _ref.onClick,
    dataTrackClickEvent = _ref.dataTrackClickEvent,
    dataTrackClickEventCategory = _ref.dataTrackClickEventCategory;
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    onClick: onClick,
    className: classNames('Button', className),
    "data-track-click-event": dataTrackClickEvent,
    "data-track-click-event-category": dataTrackClickEventCategory
  }, children);
};
AnchorButton.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  dataTrackClickEvent: PropTypes.string,
  dataTrackClickEventCategory: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]).isRequired
};
export default AnchorButton;